import { isEmpty } from 'lodash-es';
import moment from 'moment';

export const isInDifferentialShiftWindow = ({ job, tenantSettings, currentDispatchCompany }) => {
    let { contract, startTime } = job;

    if (!startTime || !currentDispatchCompany || !contract) {
        return false;
    }

    // Order of operations
    // 1. If the customer has alternate payroll, use companyShiftDifferentials (it is handled in the backend)
    // 2. If the dispatching office has hasCustomShiftDifferential = true, check custom hours - if they are set, use them, if not, don't use shift diffentials
    // 3. If 2 is false, check if tenant has companyShiftDifferentialStart/End, if yes, use the them, if not, no shift diff

    let hours = {};

    // Scenario 1
    if (contract.useAlternativePayroll) {
        hours = contract.companyShiftDifferentialHours;
    } else {
        if (currentDispatchCompany && currentDispatchCompany.hasCustomShiftDifferential) {
            // Scenario 2
            hours = currentDispatchCompany.customShiftDifferentialHours;
        } else if (tenantSettings?.enableRegularShiftDifferential && tenantSettings?.regularShiftDifferentialStart && tenantSettings?.regularShiftDifferentialEnd) { // Scenario 3
            // Scenario 3
            const start = moment(tenantSettings.regularShiftDifferentialStart);
            const end = moment(tenantSettings.regularShiftDifferentialEnd);

            hours = {
                startHour: start.hour(),
                startMinute: start.minute(),
                endHour: end.hour(),
                endMinute: end.minute(),
            };
        }
    }

    if (isEmpty(hours) || hours === null) {
        return false;
    }

    // Detect if startTime is in format HH:mm
    if (typeof startTime === 'string' && startTime.length === 5) {
        const [hh, mm] = job.startTime.split(':').map(Number);
        startTime = moment().set({ hour: hh, minute: mm });
    } else {
        startTime = moment(startTime);
    }

    const shiftTimeStart = moment().set({ hour: hours.startHour, minute: hours.startMinute });
    const shiftTimeEnd = moment().set({ hour: hours.endHour, minute: hours.endMinute });

    if (shiftTimeEnd.isBefore(shiftTimeStart)) {
        shiftTimeEnd.add(1, 'day');
    }
    if (startTime.isBefore(shiftTimeStart)) {
        startTime.add(1, 'day');
    }

    return startTime.isBetween(shiftTimeStart, shiftTimeEnd, null, '[]');
};

export const getShiftDifferentialWarning = (options) => {
    if (isInDifferentialShiftWindow(options)) {
        return 'This job will be processed as a shift differential job.';
    }

    return null;
};